import React from "react";
import { Routes, Route } from "react-router-dom";
import DashboardAgents from './../../../Screen/Admin/DashboardAgents';
import Agents from "./../../../Screen/Admin/agents";
import Client from "./client";
import NewPreventivo from "../../../Screen/User/newPreventivo";
export const AgentsRoutes = () => {

    return (
        <Routes>
            <Route index element={<Agents />} />
            <Route path="/dashboard" element={<DashboardAgents />} />
            <Route path="/dashboard/clients" element={<Client />} />
            <Route path="/dashboard/configurations" element={<NewPreventivo />} />
            <Route path="/dashboard/clients/configurations" element={<NewPreventivo />} />
        </Routes>
    );
}